import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'week' })
export class WeekPipe implements PipeTransform {
	transform(value: Date): string {
		return moment(value).isoWeeks().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
	}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/pipes/week.pipe.ts